module.exports = __webpack_public_path__ + "static/media/flash.66360fbc.svg";